// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-upload-container {
    position: relative;
}

.image-wrapper {
    position: relative;
}

.uploaded-image {
    max-width: 100%;
    max-height: 190px;
}

.removebutton1 {
    position: absolute;
    color: rgb(221, 11, 11);
    border: none;
    cursor: pointer;
    font-size: 25px;
    width: 10px;
    height: 20px;
    margin-top: -15px;
    background-color: transparent;
    margin-left: -30px;
}

.upload-label {
    display: block;
    cursor: pointer;
    text-align: center;
    padding: 10px;
    border: 1px dashed #ccc;
    border-radius: 5px;
    padding-top: -50px;
}

.addButton {
    background-color: white;
    border: none;
    color: #1e40af;
    width: 2.5%;
    float: right;
}
`, "",{"version":3,"sources":["webpack://./src/components/upload-image/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;AAChB","sourcesContent":[".image-upload-container {\n    position: relative;\n}\n\n.image-wrapper {\n    position: relative;\n}\n\n.uploaded-image {\n    max-width: 100%;\n    max-height: 190px;\n}\n\n.removebutton1 {\n    position: absolute;\n    color: rgb(221, 11, 11);\n    border: none;\n    cursor: pointer;\n    font-size: 25px;\n    width: 10px;\n    height: 20px;\n    margin-top: -15px;\n    background-color: transparent;\n    margin-left: -30px;\n}\n\n.upload-label {\n    display: block;\n    cursor: pointer;\n    text-align: center;\n    padding: 10px;\n    border: 1px dashed #ccc;\n    border-radius: 5px;\n    padding-top: -50px;\n}\n\n.addButton {\n    background-color: white;\n    border: none;\n    color: #1e40af;\n    width: 2.5%;\n    float: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
